import { useMutation, useQueryClient } from '@tanstack/react-query';
import { switchRole } from '../auth-api.service';
import { SwitchRoleRequest } from 'common/types/services/api/user/switch-role-request';
import { AuthRole } from 'common/enums/enums';
import { QueryKey } from 'common/enums/query-key';

export const useSwitchRoleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SwitchRoleRequest) => switchRole(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.User] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.User, 'profile'] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.Notifications] });
    },
  });
};

export interface SwitchRolePayload {
  roleName: AuthRole;
}
